import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { validateForm } from '@app/functions/validate-form';
import { TaskTemplate } from '@app/models/tasks/task-template.model';
import { OnboardingTaskTemplateTable } from '@app/modules/employees/services';
import { DeprecatedTaskTemplateForm } from '@app/modules/forms/company/components';
import { AnalyticService, NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';

@Component({
    templateUrl: './onboarding-task-templates-store.template.html',
    styleUrls: ['./onboarding-task-templates-store.style.scss'],
})
export class OnboardingTaskTemplatesStoreView implements OnInit {
    isLoading = true;
    title = 'Create Onboarding Task';
    taskTemplate: TaskTemplate = new TaskTemplate();
    saveEvent: AnalyticEvents;
    events = AnalyticEvents;

    constructor(
        public table: OnboardingTaskTemplateTable,
        public analytics: AnalyticService,
        private auth: AuthService,
        private notify: NotifyService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.saveEvent = AnalyticEvents.OnboardingTaskTemplateCreated;
        if (this.route.snapshot.data.models) {
            this.title = 'Edit Onboarding Task';
            this.taskTemplate = this.route.snapshot.data.models.get('taskTemplate');
            this.saveEvent = AnalyticEvents.OnboardingTaskTemplateEdited;
        }
    }

    ngOnInit(): void {
        this.taskTemplate.taskType = 'onboarding';
        this.isLoading = false;
    }

    cancel(event: MouseEvent): void {
        event.preventDefault();
        this.analytics.trackEvent(AnalyticEvents.OnboardingTaskTemplateCancelled);
        this.router.navigate(['/employees', 'settings', 'onboarding', 'tasks']);
    }

    async save(tasktemplateForm: DeprecatedTaskTemplateForm): Promise<void> {
        validateForm(tasktemplateForm.form);

        if (tasktemplateForm.form.invalid) {
            return;
        }

        try {
            await tasktemplateForm.attachEmployeeFilters();
            await this.taskTemplate.param('company', this.auth.company.id).save();

            this.analytics.trackEvent(this.saveEvent);
            this.router.navigate(['..'], { relativeTo: this.route });
            this.notify.success('Onboarding Task Saved');
        } catch (err) {
            this.notify.error(err);
        }
    }
}
